module.exports = __webpack_public_path__ + "img/logo_v1.bb02bdad.png";